import { configureStore } from "@reduxjs/toolkit"
import casesReducer from "./slices/casesSlice"
import offersReducer from "./slices/offersSlice"
import offerDataReducer from "./slices/offerDataSlice"
import selectedProfileReducer from "./slices/selectedProfileSlice"
import notificationsReducer from "./slices/notificationSlice"
import valueListsReducer from "./slices/valueListSlice"
import loaderReducer from "./slices/loaderSlice"
import snackbarItemReducer from "./slices/snackbarItemSlice"
import profilesReducer from "./slices/profilesSlice"
import pendingRequestsReducer from "./slices/pendingRequestsSlice"
import counterReducer from "./slices/counterSlice"
import beErrorReducer from "./slices/beErrorSlice"
import dashboardFiltersReducer from "./slices/dashboardFiltersSlice"
import branchesReducer from "./slices/branchesSlice"
import caseEventsReducer from "./slices/caseEventsSlice"

export const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    counter: counterReducer,
    cases: casesReducer,
    caseEvents: caseEventsReducer,
    offers: offersReducer,
    offerData: offerDataReducer,
    valueLists: valueListsReducer,
    selectedProfile: selectedProfileReducer,
    loader: loaderReducer,
    snackbarItem: snackbarItemReducer,
    profiles: profilesReducer,
    pendingRequests: pendingRequestsReducer,
    beError: beErrorReducer,
    dashboardFilters: dashboardFiltersReducer,
    branches: branchesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
